import Vue, { CreateElement, RenderContext } from "vue"
export default Vue.extend({
    name: "MenuItem",
    functional: true,
    props: {
        icon: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: ""
        },
        iconType: {
            type: String
        }
    },
    render(
        h: CreateElement,
        context: RenderContext<{
            icon: string
            title: string
            iconType: string
        }>
    ) {
        const { icon, title, iconType } = context.props
        const vnodes = []
        if (icon) {
            vnodes.push(<i class={"myicon" + " " + icon} />)
        }
        if (iconType) {
            vnodes.push(<a-icon type={iconType} />)
        }

        if (title) {
            vnodes.push(<span style="margin-left:6px">{title}</span>)
        }
        return vnodes
    }
})
